import * as actions from "./template.actions";
import * as sagas from "./template.sagas";
import * as reducers from "./template.reducers";
import * as selectors from "./template.selectors";

export { actions, sagas, reducers, selectors };